'use client';

import React from 'react';
import PrivacyPolicy from '@/components/organisms/privacy-policy';
import DisclaimerSection from '@/components/organisms/disclaimer';

const DisclaimerTastic = ({data}: any) => {
    const privacyPolicyData = data.data.dataSource;
    console.log("Disclaimer data here>>>>>>>>>>>>>>>>>>>>", privacyPolicyData)
    
    return <DisclaimerSection privacyPolicyData={privacyPolicyData} />
};

export default DisclaimerTastic;